import { render, staticRenderFns } from "./RibbonedImage.vue?vue&type=template&id=049df596&scoped=true&"
import script from "./RibbonedImage.vue?vue&type=script&lang=js&"
export * from "./RibbonedImage.vue?vue&type=script&lang=js&"
import style0 from "./RibbonedImage.vue?vue&type=style&index=0&id=049df596&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049df596",
  null
  
)

export default component.exports